module.exports = __webpack_public_path__ + "img/settings.ce4369a3.svg";